<template>
  <section class="sec bg-light form-sec">
    <div class="container container-lg">
      <div class="search-form-area">
        <div class="row">
            <div class="col-sm-12 form-heading">
                <h2 class="sec-title">FILTER THE FUNDERS</h2>
            </div>
            <div class="col-sm-12  form-all directory">
              <div class="form-all-in m-auto">
                <form action="#">
                  <div class="row expanded">
                    <country-drop-down
                      type="directory"
                      v-on:user-select="runSearch"/>
                    <sector-drop-down
                      type="directory"
                      v-on:user-select="runSearch"
                      :withIcon="false"/>
                    <investor-type-drop-down
                      type="directory"
                      v-on:user-select="runSearch"
                      :withIcon="false"/>
                    <capital-type-drop-down
                      type="directory"
                      v-on:user-select="runSearch"
                      :withIcon="false"/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <p v-if="!loadingResults && !noResults" class="text-right text-primary lead"><strong>
        {{ getNumResults }} {{getNumResults == '1' ? 'result' : 'results'}}
        <span v-if="hasSearched">
          in – {{ (searchTime/1000).toPrecision(3) }} seconds.
        </span>
      </strong></p>
      <p v-if="noResults" class="text-right text-primary lead"><strong>
        No results returned, please broaden your search parameters.
      </strong></p>
    </div>
    <div v-if="loadingResults" class="container container-md">
      <h4>Loading results...</h4>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CapitalTypeDropDown from './dropdowns/CapitalTypeDropDown.vue'
import CountryDropDown from './dropdowns/CountryDropDown.vue'
import SectorDropDown from './dropdowns/SectorDropDown.vue'
import InvestorTypeDropDown from './dropdowns/InvestorTypeDropDown.vue'

export default {
  name: "SearchBar",
  data: function () {
    return {
      searchTime: undefined,
      hasSearched: false,
      numberOfResults: undefined,
      noResults: false,
      debouncedTimerId: null,
      debouncing: false
    }
  },
  components: {
    'capital-type-drop-down': CapitalTypeDropDown,
    'country-drop-down': CountryDropDown,
    'sector-drop-down': SectorDropDown,
    'investor-type-drop-down': InvestorTypeDropDown
  },
  computed: {
    ...mapGetters({
      results: "results",
      sectors: "sectors",
      capitalTypes: "capitalTypes",
      providerTypes: "providerTypes",
      countries: "countries",
      getNumResults: 'getNumResults',
      loadingResults: 'loadingResults'
    })
  },
  watch: {
    'getNumResults': function (newValue, oldValue) {
      if (oldValue == 0 && newValue == 0) {
        this.noResults = true
      } else if (oldValue == 0 && newValue > 0) {
        this.setLoadingResults(false)
      }
    }
  },
  methods: {
    ...mapActions({
      search: "search",
    }),
    ...mapMutations([
      'setResults',
      'setLoadingResults',
      'resetRange'
    ]),
    runSearch: function() {
      if (this.debouncedTimerId) {
        clearTimeout(this.debouncedTimerId);
      }
      var vm = this
      this.setLoadingResults(true)
      this.debouncedTimerId = setTimeout(() => {
        vm.debouncedTimerId = null;
        vm.setResults([])
        vm.resetRange()
        vm.noResults = false
        var timeBefore = performance.now();
        vm.search().then((r) => {
          vm.hasSearched = true
          vm.searchTime = performance.now() - timeBefore
        });
      }, 1500);
    },
  },
  mounted(){
     $('.jquerydropdown').multiselect();

     $('.dropdown-menu').click(function(e) {
       e.stopPropagation();
     });

     $(function () {
       $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').tooltip();
     })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBars/DirectorySearchBar.vue